import React from "react";

function ToggleUp({ color = "#3D348B", width = 9, height = 6 }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`1 0 ${height} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.02222 5.0389L4.5873 1.60399L1.15239 5.0389"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default ToggleUp;
